import React,{useState, useEffect} from 'react'
import '../Pages/style.css'
import sabreicon from "../assets/sabre.png"
import { FaSignOutAlt } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Navbar = ({loginClick, defaultState, logoutClick}) => {
  const [clicked, setClicked] = useState(true)
  const [loutclicked, setLoutClicked] = useState(true)
  const [entered, setEntered] = useState("0")
  const navigate = useNavigate()
  
  useEffect(()=>{
    checkCurrentState();
  })

  const checkCurrentState = () =>{
    // console.log(`default State: ${defaultState}`)
    setEntered(defaultState)
  }
  
  const loginClicked = () =>{
    setClicked(!clicked)
    loginClick(clicked)
  }

  const logoutClicked = () =>{
    setLoutClicked(!loutclicked)
    logoutClick(loutclicked)
  }

  const homeClick = () =>{
    navigate ('/')
  }

  return (
    <div className='navbarContian'>
        <img id='imgIcon' src={sabreicon} alt="sabre icon" onClick={homeClick}/>
        {entered === "1" ? <span id='loginclick' onClick={loginClicked}>LOGIN</span> : entered === "2" ? <span id='loginclick' onClick={logoutClicked}>LOGOUT</span> : ""}
        {entered === "1" ? <FiLogIn id='loginclick_' onClick={loginClicked}/> :  entered === "2" ? <FaSignOutAlt id='loginclick_' onClick={logoutClicked}/>  :  ""}
        
    </div>
  )
}

export default Navbar